import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import rightArrow from '../assets/graphics/arrow-right.svg';

class RightArrow extends Component {

    render() {

        return(
            <ReactSVG src={ rightArrow } className="right-arrow" />
        );

    }

}

export default RightArrow;


// WEBPACK FOOTER //
// ./src/components/right-arrow.js